import { MachineGuards } from 'common/bento/types/MachineConfig';

import { getServerErrorCode } from '../../../../../common/errors/utils';
import { ApplicationType, ErrorCodes } from '../../../types';
import getShouldSendInvitations from '../libs/getShouldSendInvitations';
import { Model } from './model';

export enum Guard {
  CanSeeResetPrompt = 'canSeeResetPrompt',
  ShowNewOnboardingBeneficiaryFlow = 'showNewOnboardingBeneficiaryFlow',
  HasBeneficiaries = 'hasBeneficiaries',
  HasAlreadyRegisteredBeneficiaries = 'hasAlreadyRegisteredBeneficiaries',
  ShouldSendInvitations = 'shouldSendInvitations',
  IsFollowup = 'isFollowup',
  IsSiretReserved = 'isSiretReserved',
}

const guards: MachineGuards<Model, Guard> = {
  canSeeResetPrompt: ({ getModuleData }) => {
    const { company } = getModuleData().viewer;

    if (!company) {
      return false;
    }

    return company.canResetOnboarding;
  },
  hasAlreadyRegisteredBeneficiaries: ({ getModuleData }) => {
    return getModuleData().viewer.company.metadata
      .hasRegisteredAllBeneficiaries;
  },
  hasBeneficiaries: ({ getModuleData }) => {
    const { company } = getModuleData().viewer;

    // Account owner is counted as a legal beneficiary, which is why we must check for > 1.
    return company.legalBeneficiaries.length > 1;
  },

  isFollowup: ({ getModuleData }) => {
    // If we have a KYB review, the application was already submitted at least once
    return Boolean(getModuleData().viewer.company.lastKybReview);
  },

  isSiretReserved: (_, event) => {
    if (
      'error.platform.registerCompanyBeneficiaries' === event.type ||
      'error.platform.sendAllCompanyInvitations' === event.type
    ) {
      return (
        ErrorCodes.COMPANY_ALREADY_EXISTS === getServerErrorCode(event.data)
      );
    }
    return false;
  },

  shouldSendInvitations: ({ getModuleData }) => {
    const { applicationType } = getModuleData();

    return getShouldSendInvitations({
      applicationType,
    });
  },
  showNewOnboardingBeneficiaryFlow: ({ getModuleData }) => {
    const { applicationType, showNewOnboardingBeneficiaryFlow } =
      getModuleData();

    return (
      applicationType === ApplicationType.Standard &&
      showNewOnboardingBeneficiaryFlow
    );
  },
};

export default guards;
